module.exports = __webpack_public_path__ + "img/exclamation-mark.59fa6199.svg";